<script setup>
import { CAMPAIGN_CONFIG } from '../config.js'
import { useMysterySoundGuessStore } from '../stores/mysterySoundGuess'
import { storeToRefs } from 'pinia'
import { onMounted, ref } from 'vue'
import confetti from 'canvas-confetti'

const { copy, confetti: confettiConfig } = CAMPAIGN_CONFIG

const confettiCanvas = ref(null)

let confettiInstance = confetti.create(confettiCanvas.value, { resize: true, useWorker: true })

let customShape = null
if (confettiConfig.shapePath) {
  customShape = confetti.shapeFromPath({
    path: confettiConfig.shapePath,
    matrix: confettiConfig.shapeMatrix,
  })
}

const mysterySoundGuess = useMysterySoundGuessStore()
const { name } = storeToRefs(mysterySoundGuess)

async function fireConfetti() {
  confettiInstance({
    particleCount: 500,
    spread: 120,
    angle: 90,
    gravity: 1,
    startVelocity: 60,
    ticks: 800,
    origin: { y: 0, x: 0.5 },
    colors: confettiConfig.colors,
  })

  if (customShape) {
    confettiInstance({
      particleCount: 20,
      spread: 120,
      angle: 90,
      gravity: 0.8,
      startVelocity: 30,
      ticks: 800,
      origin: { y: 0, x: 0.5 },
      colors: [confettiConfig.shapeColor],
      shapes: [customShape],
    })
  }
}

onMounted(() => {
  fireConfetti()
})
</script>

<template>
  <div>
    <canvas
      ref="confettiCanvas"
      style="position: fixed; pointer-events: none; top: 0; left: 0; width: 100vw; height: 100vh; z-index: 9999"
    />
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div class="text-xl text-white mb-6" v-html="copy.correct(name)" />

    <button
      data-testid="confetti-button"
      class="font-heading font-semibold bg-brand-primary hover:bg-brand-primary-dark w-full rounded-full px-2 py-1 text-xl uppercase transition-colors"
      @click="fireConfetti"
    >
      {{ copy.correctButton }}
    </button>
  </div>
</template>
